/** All available analytics types for planning budget requests */
export enum BudgetRequestAnalyticsTypeEnum {
  /** Take analytica by plan */
  PLAN = 'PLAN',
  /** Take analytica by fact kass documents */
  FACT_KASS = 'FACT_KASS',
  /** Take analytica by fact sale documents */
  FACT_SALE = 'FACT_SALE',
}
